import { cloneElement } from "react";
import { ButtonTab } from "@bca/ui-library";

export const TabButton = ({ children, ...props }: any) => {
  const css = `
  &:first-of-type {
    margin-left: 0
  }
  &:last-of-type {
    margin-right: 0;
  }
  `;
  return (
    <ButtonTab
      height="73px"
      width="134px"
      color={props.isActive ? "footer-blue" : "primary-white"}
      bg={props.isActive ? "primary-white" : "rgba(255, 255, 255, 0.15)"}
      mx="3px"
      borderRadius="6px 6px 0 0"
      padding="14px 6px 10px 6px"
      css={css}
      {...props}
    >
      {cloneElement(children, props, props.isActive)}
    </ButtonTab>
  );
};

export const LoadingTabButton = ({ children, ...props }: any) => {
  const css = `
  &:first-of-type {
    margin-left: 0
  }
  &:last-of-type {
    margin-right: 0;
  }
  `;
  return (
    <ButtonTab
      height="73px"
      width="134px"
      color={props.isActive ? "footer-blue" : "primary-white"}
      bg={"rgba(255, 255, 255, 0.15)"}
      mx="3px"
      borderRadius="6px 6px 0 0"
      padding="14px 6px 10px 6px"
      css={css}
      {...props}
    >
      {cloneElement(children, props, props.isActive)}
    </ButtonTab>
  );
};
